import { getFieldState } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import useFormState from 'src/components/10-atoms/form/hooks/useFormState';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { useCreateNoteMutation } from 'src/modules/exam-preparation/graphql/notes/create';
import { useUpdateNoteMutation } from 'src/modules/exam-preparation/graphql/notes/update';
export default function useData(note, draftApply) {
    const [createMutationState, createMutationActions] = useCreateNoteMutation();
    const [updateMutationState, updateMutationActions] = useUpdateNoteMutation();
    const [formState, formActions] = useFormState({
        fields: {
            title: getFieldState(note?.data.title ?? ''),
            topics: getFieldState(note?.data.topics ?? []),
            topicsInput: getFieldState(''),
        },
    }, {
        fieldValidations: {
            title({ value }) {
                if (!value || value.trim().length === 0) {
                    return 'Title is required';
                }
                if (value.length > 200) {
                    return 'Title cannot exceed 200 characters';
                }
                return true;
            },
            topics({ value }) {
                if (!Array.isArray(value)) {
                    return 'Topics must be an array';
                }
                if (value.length > 50) {
                    return 'You cannot include more than 50 topics';
                }
                // Validate each topic
                for (const topic of value) {
                    if (typeof topic !== 'string' || topic.trim().length === 0) {
                        return 'Each topic must be a non-empty string';
                    }
                    if (topic.length > 100) {
                        return 'Each topic cannot exceed 100 characters';
                    }
                }
                return true;
            },
            topicsInput: () => true,
        },
    });
    const handleSubmit = useStableCallback(() => {
        if (!formActions.validateForm()) {
            return;
        }
        const data = {
            title: formState.fields.title.value.trim(),
            topics: formState.fields.topics.value,
        };
        if (draftApply) {
            draftApply(data);
            return;
        }
        if (note) {
            updateMutationActions.submit({
                variables: {
                    data: {
                        id: note.id,
                        data,
                    },
                },
            });
        }
        else {
            createMutationActions.submit({
                variables: {
                    data,
                },
            });
        }
    });
    const state = {
        form: formState,
        createMutation: createMutationState,
        updateMutation: updateMutationState,
        draftOnly: !!draftApply,
    };
    const actions = {
        form: formActions,
        handleSubmit,
    };
    return [state, actions];
}
